import { supabase } from '@/integrations/supabase/client';

export type ActivityEventType =
  | 'login'
  | 'page_view'
  | 'book_create'
  | 'book_update'
  | 'book_delete'
  | 'placement_request'
  | 'placement_message';

export async function logActivity(
  eventType: ActivityEventType,
  opts: { path?: string; metadata?: Record<string, unknown> } = {},
) {
  try {
    const { data: { user } } = await supabase.auth.getUser();
    if (!user) return;
    await (supabase as any).from('user_activity_events').insert({
      user_id: user.id,
      event_type: eventType,
      path: opts.path ?? null,
      metadata: opts.metadata ?? {},
    });
  } catch {
    // best-effort; never break user flow
  }
}
